import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginActions } from "src/redux/actions/auth";
import { setToken, setRefreshToken, setTokenExpDate } from "src/services/localStorage";

/**
 * Handles cross-origin SSO handoff from the student app (maneno-react).
 * When a teacher signs in on app.readgriffin.co.uk, they are redirected here
 * with auth tokens in the query string (?t=...&rt=...&exp=...&uid=...).
 * This component seeds localStorage and Redux, then navigates to the dashboard.
 */
const GriffleSso: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("t");
    const refreshToken = params.get("rt");
    const exp = params.get("exp");
    const uid = params.get("uid");

    if (token && uid) {
      setToken(token);
      if (refreshToken) setRefreshToken(refreshToken);
      if (exp) setTokenExpDate(Number(exp));

      dispatch(loginActions.success({ access_token: token, userId: uid } as any));

      window.history.replaceState({}, "", "/griffle/dashboard");
      navigate("/griffle/dashboard", { replace: true });
    } else {
      navigate("/griffle/login", { replace: true });
    }
  }, []);

  return null;
};

export default GriffleSso;
